import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import DeckGL from "@deck.gl/react";
import "mapbox-gl/dist/mapbox-gl.css";
import { computeMidGridCell } from "../../../utils/utils";
import { Map } from "react-map-gl";

export default function DeckglBase({
  layers,
  draggingWhileEditing,
  setDeckGLRef,
}) {
  const cityIOdata = useSelector((state) => state.cityIOdataState.cityIOdata);
  const menuState = useSelector((state) => state.menuState);
  const [viewState, setViewState] = useState();
  const [original, setOriginal] = useState(computeMidGridCell(cityIOdata));
  const ref = useRef(null);

  // when ref is set, set the deckGLRef
  useEffect(() => {
    ref.current && setDeckGLRef(ref);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref]);

  const viewControlButton =
    menuState?.viewSettingsMenuState?.VIEW_CONTROL_BUTTONS;

  // **
  //  * resets the camera viewport
  //  * to cityIO header data
  //  * https://github.com/uber/deck.gl/blob/master/test/apps/viewport-transitions-flyTo/src/app.js
  //  *
  const setViewStateToTableHeader = () => {
    const midGrid = computeMidGridCell(cityIOdata);
    return {
      ...viewState,
      longitude: midGrid[0],
      latitude: midGrid[1],
      zoom: 15,
      orthographic: false
    };
  };

  useEffect(() => {
    const midGrid = computeMidGridCell(cityIOdata);

    switch (viewControlButton) {
      case "RESET_VIEW_BUTTON":
        setViewState((prevViewState) => ({
          ...prevViewState,
          longitude: midGrid[0],
          latitude: midGrid[1]
        }));
        setOriginal([midGrid[0],midGrid[1]]);
        break;

      case "CITY_CENTRE_BUTTON":
        setViewState((prevViewState) => ({
          ...prevViewState, 
          longitude: 36.23409840243664,
          latitude:  49.99103959578231
        }));
        setOriginal([36.23409840243664,49.99103959578231]);
        break;

      case "NEIG_BUTTON":
        setViewState((prevViewState) => ({
          ...prevViewState,
          longitude: 36.360847688155424,
          latitude: 50.03757165190652
        }));
        setOriginal([36.360847688155424,50.03757165190652]);

        break;
      default:
        break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewControlButton]);

  // fix deck view rotate
  useEffect(() => {
    document
      // ! a more aggressive method which prevents all right click context menu [ OLD: .getElementById("deckgl-wrapper")]
      .addEventListener("contextmenu", (evt) => evt.preventDefault());
    // zoom map on CS table location
    setViewStateToTableHeader();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onViewStateChange = ({ viewState, interactionState, oldViewState }) => {

      viewState.zoom = Math.min(17, viewState.zoom);
      viewState.zoom = Math.max(13, viewState.zoom);  
      if(viewState.zoom === 13 || viewState.zoom === 17) {
        setViewState(oldViewState);
        return
      }
      if(original){
        if(viewState.longitude > original[0] + 0.01 || viewState.longitude < original[0] - 0.01) {
          viewState.longitude = oldViewState.longitude;
        }
        if(viewState.latitude > original[1] + 0.01 || viewState.latitude < original[1] - 0.01) {
          viewState.latitude = oldViewState.latitude;
        }  
      }
    setViewState(viewState);
  };

  return (
    
    <DeckGL
      ref={ref}
      viewState={viewState}
      initialViewState={setViewStateToTableHeader()}
      onViewStateChange={onViewStateChange}
      layers={layers}
      controller={{
        touchZoom: true,
        touchRotate: true,
        dragPan: true,
        dragRotate: !draggingWhileEditing,
        keyboard: false,
      }}
    >
      <Map
        mapStyle="mapbox://styles/relnox/ck0h5xn701bpr1dqs3he2lecq?fresh=true"
        mapboxAccessToken={process.env.REACT_APP_MAPBOX_TOKEN}
      />
    </DeckGL>
  );
}
